import React from 'react'
import './CreatorPro.css'
import logo from '../../../assets/img/logo.png'
import { DoneAll, SearchSharp, MoreHoriz, HourglassEmptyRounded } from '@material-ui/icons'
import Modal from 'react-modal'
import Unsplash from 'unsplash-js'
import axios from 'axios'

import * as firebase from "firebase/app"
import "firebase/auth"

import { API_URL } from '../../../config'
import { themeColors } from '../../../constants'
import ProPayge from '../../ProPayge/ProPayge'

const yt_modal_styles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		width: '60%',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		padding: 0,
		background: '#0091EA',
		borderRadius: 0,
	}
}

const img_one = "https://images.unsplash.com/photo-1561016444-14f747499547?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80"
const default_background = {
  index: 0,
  imgSearchQuery: 'payge_default_background_image',
  urls: {
    regular: img_one
  },
  user: {
    name: "Jason Dent",
    links: {html: "https://unsplash.com/@jdent"}
  }
}

// API setups
const unsplash = new Unsplash({ accessKey: "Besw1gJSUAJg5eHf3vgVESKrM_VPp6MY2xO4SXnGqX8" });
const DRIVE_API_KEY = "AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc"

export default class CreatorPro extends React.Component {

  constructor(props) {
    super(props)
    this.content = React.createRef()
    this.state = {
      selected_theme: "one",
      video_isopen: false,
      backgrounds: [],
      selected_bg: undefined,
      img_search_text: undefined,
      payge_created: false,
      is_loading: false,
      copyLabelText: 'Copy to clipboard',
      input_errors: [false, false, false],
      driveLinkValid: false,
      // 0 - pending, 1 - success, 2 - error
      driveSelectedFlag: 0,
      pipelineStepStates: [0, 0, 0, 0],
      error_indicator_mode: false,
      fileUrlInput: undefined,
      fileNameInput: undefined,
      fileDescriptionInput: undefined,
      driveFile: undefined,
      dropboxFile: undefined,
      new_payge_data: undefined,
      userUid: undefined,
      isFileSelectOpen: true,
      pipelineStep: 0,
      isPipelineFlow: true,
      fileProviderStates: [0, 0],
      landingLinks: [],
      isNewLinkModalOpen: false,
      newLinkName: undefined,
      newLinkURL: undefined,
      isBackgroundChooserOpen: false,
      landingLogo: undefined,
      // input properties
      landingTitle: undefined,
      landingDescription: undefined,
      fileName: undefined,
      // customize panel
      isCustomizePanelOpen: false,
      currentThemeColorName: themeColors[0].name,
      currentSidebarStyle: 'diagonal',
      isLoading: false,
      isPublishError: false,
      newPaygeData: undefined,
    }
  }

  // landing links
  openNewLinkModal = () => {
    this.setState({isNewLinkModalOpen: true})
  }
  addNewLandingLink = (name, link) => {
    const { landingLinks } = this.state
    landingLinks.push({name: name, link: link})
    this.setState({landingLinks: landingLinks, newLinkURL: undefined, newLinkName: undefined, isNewLinkModalOpen: false})
  }
  removeLandingLink = (index) => {
    const { landingLinks } = this.state
    landingLinks.splice(index, 1)
    console.log(`new links: ${landingLinks.length}`)
    this.setState({landingLinks: landingLinks})
  }

  setSelectedTheme = (theme) => {
    this.setState({selected_theme: theme})
  }

  closeYouTubeModal = () => {
    if (this.state.video_isopen) {
      this.setState({video_isopen: false})
    }
  }

  // input properties
  onLandingTitleChange = (text) => {
    // console.log(text)
    this.setState({landingTitle: text})
  }
  onLandingDescriptionChange = (text) => {
    this.setState({landingDescription: text})
  }
  onFileNameChange = (text) => {
    this.setState({fileName: text})
  }

  // handling Input changes
  handleFileURLTextChange = (e) => {
    let input = e.target.value
    let new_errors = this.state.input_errors
    // checking for empty input
    if (input.trim() === '') {
      new_errors[0] = true
    } else {
      new_errors[0] = false
    }
    this.setState({
      fileUrlInput: input,
      input_errors: new_errors,
      driveLinkValid: false,
    })
  }
  handleFileNameTextChange = (e) => {
    let input = e.target.value
    let new_errors = this.state.input_errors
    // checking for empty input
    if (input.trim() === '') {
      new_errors[1] = true
    } else {
      new_errors[1] = false
    }
    this.setState({
      fileNameInput: input,
      input_errors: new_errors
    })
  }
  handleFileDescriptionTextChange = (e) => {
    let input = e.target.value
    let new_errors = this.state.input_errors
    // checking for empty input
    if (input.trim() === '') {
      new_errors[2] = true
    } else {
      new_errors[2] = false
    }
    this.setState({
      fileDescriptionInput: input,
      input_errors: new_errors
    })
  }

  // copying to clipboard
  copyLinkToClipboard = (link) => {
    let context = this
    navigator.permissions.query({name: "clipboard-write"}).then(result => {
      if (result.state == "granted" || result.state == "prompt") {
        // writing link to clipboard
        navigator.clipboard.writeText(link).then(function() {
          console.log("clipboard copied")
          // quick UI changes
          context.showCopyUIChanges()
        }, function() {
          console.log("clipboard error")
        });
      }
    });
  }
  showCopyUIChanges = () => {
    this.setState({copyLabelText: 'Copied'})
    setTimeout(() => {
      this.setState({copyLabelText: 'Copy to clipboard'})
    }, 500)
  }

  // selecting a bg
  selectBg = (index) => {
    let bg = this.state.backgrounds[index]
    bg["index"] = index
    bg["imgSearchQuery"] = this.state.img_search_text
    this.setState({
      selected_bg: bg
    })
  }

  // img search text change
  handleImageSearchTextChange = (e) => {
    this.setState({
      img_search_text: e.target.value
    })
    // disabled due to rate limiting
    // this.getUnsplashImages(e.target.value)
  }
  handleOnKeyDown = (e) => {
		if (e.keyCode === 13) this.getUnsplashImages(e.target.value)
	}

  // search for images from unsplash
  getUnsplashImages = (search) => {
    unsplash.search.photos(search, 1, 40)
      .then(res => res.json())
      .then(json => {
        console.log(json)
        let selected_bg = default_background
        let backgrounds = json.results
        if (backgrounds.length > 0) {
          selected_bg = backgrounds[0]
          selected_bg["index"] = 0
          selected_bg["imgSearchQuery"] = search
        } 
        this.setState({
          backgrounds: backgrounds,
          selected_bg: selected_bg,
        })
      });
  }

  // verify google drive file 
  verifyDriveFile = () => {
    let input = this.state.fileUrlInput
    let new_errors = this.state.input_errors
    let driveLinkValid = this.state.driveLinkValid
    this.setState({driveFile: undefined, driveSelectedFlag: 0})

    if (!input) {return}
    // checking if it's a valid gdrive file
    let fileId = undefined
    if (input.slice(0, 24) === "drive.google.com/file/d/" || input.slice(0, 32) === "https://drive.google.com/file/d/" || input.slice(0, 31) === "http://drive.google.com/file/d/") {
      let dashSplit = input.split('/file/d/')[1]
      fileId = dashSplit.split('/')[0]
    } else if (input.slice(0, 17) === "drive.google.com/" || input.slice(0, 25) === "https://drive.google.com/" || input.slice(0, 24) === "http://drive.google.com/") {
      // checking for valid file id
      let querySplit = input.split('?')
      if (querySplit.length > 1) {
        let queries = querySplit[1].split('&')
        for (var i=0;i<queries.length;i++) {
          let query = queries[i]
          if (query.slice(0, 3) === "id=") {
            fileId = query.split('=')[1]
          }
        }
      }
    }
    if (fileId.length > 1 && fileId) {
      // getting file metadata
      axios(`https://www.googleapis.com/drive/v2/files/${fileId}?key=${DRIVE_API_KEY}`)
        .then((result) => {
          let driveFile = undefined
          if (result.status === 200) {
            driveLinkValid = true
            driveFile = result.data
          } else {
            driveLinkValid = false
            new_errors[0] = true
          }
          this.setState({
            input_errors: new_errors,
            driveLinkValid: driveLinkValid,
            driveFile: driveFile
          })
        },
        (error) => {
          driveLinkValid = false
          new_errors[0] = true
          this.setState({
            input_errors: new_errors,
            driveLinkValid: driveLinkValid,
            driveFile: undefined
          })
        }
      )
    }
  }

  // When a file is selected from Google Picker
  onDriveSelectDataChange = (data) => {
    if (data.docs) {
      this.setState({
        driveFile: undefined, 
        driveLinkValid: false, 
        dropboxFile: undefined, 
        fileProviderStates: [0, 0]
      })
      console.log(data.docs[0])
      let fileId = data.docs[0].id
      // getting file info
      axios(`https://www.googleapis.com/drive/v2/files/${fileId}?key=${DRIVE_API_KEY}`)
      .then((result) => {
        let driveFile = undefined
        let driveSelectedFlag = 0
        if (result.status === 200) {
          driveFile = result.data
        } else {
        }
        this.setState({
          driveFile: driveFile,
          fileProviderStates: [driveSelectedFlag, 0]
        })
      },
      (error) => {
        this.setState({
          driveFile: undefined,
          fileProviderStates: [2, 0]
        })
      })
    }
  }
  // When a file is selected from Dropbox Chooser
  onDropboxChooseDataChange = (files) => {
    if (files) {
      let currentFile = files[0]
      console.log(currentFile)
      this.setState({
        driveFile: undefined, 
        driveLinkValid: false, 
        dropboxFile: currentFile, 
        fileProviderStates: [0, 1]
      })
    } else {
      this.setState({
        driveFile: undefined, 
        driveLinkValid: false, 
        dropboxFile: undefined, 
        fileProviderStates: [0, 2]
      })
    }
  }
  onDownloadFileChange = () => {
    this.setState({
      driveFile: undefined,
      driveLinkValid: false,
      dropboxFile: undefined,
      fileProviderStates: [0, 0]
    })
  }
  // on new landing logo
  handleLandingLogoChange = (event) => {
    this.setState({
      landingLogo: event.target.files[0]
    })
  }

  // publish click handler
  onPublishClick = () => {
    const { driveFile, dropboxFile, landingTitle, fileName, landingDescription, landingLinks, landingLogo, 
      currentThemeColorName, currentSidebarStyle, isCustomizePanelOpen, userUid, selected_bg, isLoading } = this.state

    // loading check
    if (isLoading) { return false }
    // closing customize panel
    if (isCustomizePanelOpen) { this.setState({isCustomizePanelOpen: false}) }
    // checking for values
    if ((driveFile || dropboxFile) && landingTitle && landingDescription) {
      this.setState({isLoading: true})
      // sending new payge request
      
      let url = `${API_URL}/payge/pro/new`
      let postData = new FormData()
      postData.append('downloadName', fileName)
      postData.append('landingTitle', landingTitle)
      postData.append('landingDescription', landingDescription)
      postData.append('landingLinks', JSON.stringify(landingLinks))
      postData.append('landingThemeColor', currentThemeColorName)
      postData.append('landingSidebarStyle', currentSidebarStyle)
      postData.append('backgroundImage', JSON.stringify(selected_bg))
      postData.append('ownerUser', userUid)
      if (landingLogo) { postData.append('landingLogo', landingLogo) }
      // checking for file data
      if (driveFile) {
        postData.append('driveFile', JSON.stringify(driveFile))
        postData.append('fileProvider', 'GoogleDrive')
      } else if (dropboxFile) {
        postData.append('dropboxFile', JSON.stringify(dropboxFile))
        postData.append('fileProvider', 'Dropbox')
      } else {
        this.setState({isPublishError: true})
        setTimeout(() => {
          this.setState({isPublishError: false})
        }, 2000)
        return false
      }

      // loading indicator
      window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);

      // calling the API
      axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: postData
      })
        .then((result) => {
          let url = undefined
          if (result.status === 200) {
            if (result.data.status === "success") {
              url = result.data.payge.paygeUrl
            }
            // triggering download for unsplash photo
            unsplash.photos.downloadPhoto(selected_bg)
          }
          window.open(`${url}?new_payge=true`, '_blank')
          setTimeout(()=>{window.open('/dashboard', '_self')}, 500)
          return
        },
        (error) => {
          this.setState({
            isLoading: false,
          })
        })

    } else {
      this.setState({isPublishError: true})
      setTimeout(() => {
        this.setState({isPublishError: false})
      }, 2000)
    }
  }

  componentWillMount() {
    let self = this
    // getting auth user
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        self.setState({userUid: user.uid})
      } else {
        // User is signed out.
        window.open('/', '_self')
        return
      }
    })
  }
  componentDidMount() {
    // getting unsplash
    this.getUnsplashImages("interior")
  }

  render() {
    const { selected_theme, video_isopen, backgrounds, selected_bg, img_search_text, payge_created, driveLinkValid, userUid,
      copyLabelText, is_loading, input_errors, fileUrlInput, fileNameInput, fileDescriptionInput, driveFile, new_payge_data,
      driveSelectedFlag, isFileSelectOpen, pipelineStep, pipelineStepStates, error_indicator_mode, isPipelineFlow, landingLogo,
      dropboxFile, fileProviderStates, isNewLinkModalOpen, landingLinks, newLinkName, newLinkURL, isBackgroundChooserOpen, isPublishError,
      landingTitle, landingDescription, fileName, isCustomizePanelOpen, currentThemeColorName, currentSidebarStyle, isLoading } = this.state

    // getting theme
    let theme_one_style = ""
    let theme_two_style = ""
    let theme_three_style = ""
    if (selected_theme === "one") {
      theme_one_style = "active"
    } else if (selected_theme === "two") {
      theme_two_style = "active"
    } else if (selected_theme === "three") {
      theme_three_style = "active"
    }

    // setting error for input views
    let inputOneStyles = 'black'
    let inputTwoStyles = 'black'
    let inputThreeStyles = 'black'
    if (input_errors[0]) {
      inputOneStyles = 'red'
    }
    if (input_errors[1]) {
      inputTwoStyles = 'red'
    }
    if (input_errors[2]) {
      inputThreeStyles = 'red'
    }
    if (driveLinkValid) {
      inputOneStyles = 'green'
    }
    // styles for drive select button
    let driveButtonStyles = 'blue'
    let driveButtonText = 'Select file from Google Drive'
    if (driveSelectedFlag === 1) {
      driveButtonStyles = 'green'
      driveButtonText = driveFile.title
    } else if (driveSelectedFlag === 2) {
      driveButtonStyles = 'red'
      driveButtonText = (<>Click to try again! —&nbsp;<span className="small-text">Make sure the file is publicly viewable</span></>)
    }
    // styles for file provider buttons
    let gDriveButtonStyles = 'gray'
    let dropboxButtonStyles = 'gray'
    if (fileProviderStates[0] === 1) {
      gDriveButtonStyles = 'blue'
    } else if (fileProviderStates[0] === 2) {
      gDriveButtonStyles = 'red'
    }
    if (fileProviderStates[1] === 1) {
      dropboxButtonStyles = 'blue'
    } else if (fileProviderStates[1] === 2) {
      dropboxButtonStyles = 'red'
    }

    // styles for the pipeline
    let pipeline_errors = []
    pipelineStepStates.map((status) => {
      let value = 'none'
      if (status === 2 && error_indicator_mode) { value = 'error' }
      pipeline_errors.push(value)
    })
  
    // setting up get payge element
    let getPaygeElemenet = false
    if (is_loading) {
      getPaygeElemenet = (
        <>
          <div class="shimmer-container">
            <div className="name shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer short" />
          </div>
        </>
      )
    } else if (new_payge_data) {
      getPaygeElemenet = (
        <>
          <div className="success-container">
            <span className="done-text">Your download Payge is ready!</span>
            <div className="link-container">
              <a href={new_payge_data.paygeUrl} target="_blank" style={{textDecoration: 'none'}}>
                <span className="link"><span className="payge-url-text">Payge Link —&nbsp;</span><b>{new_payge_data.paygeUrl}</b></span>
              </a>
              <span className="copy" onClick={()=>this.copyLinkToClipboard(new_payge_data.paygeUrl)}>{copyLabelText}</span>
            </div>
          </div>
        </>
      )
    }

    // getting progress
    let progressPercent = 0
    if (driveFile || dropboxFile) {
      progressPercent += 40
    }
    if (landingTitle && landingTitle.trim() !== "") { progressPercent += 20 }
    if (landingDescription && landingDescription.trim() !== "") { progressPercent += 20 }
    if (fileName && fileName.trim() !== "") { progressPercent += 20 }
 
    return (
      <>
        {
          userUid ? (
            <div onClick={this.closeYouTubeModal.bind(this)} id="creator-pro">
              <section className="pro-dashboard-topbar">
                <div className="logo">
                  <a href="/dashboard" style={{display: 'flex'}}>
                    <img src={logo} className="logo-img" />
                  </a>
                  <a href="/dashboard" style={{textDecoration: 'none'}}>
                    <span className="page-title">Payge</span>
                  </a>
                  <span className="creator-title">Creator</span>
                </div>
                <div style={{display:'flex',alignSelf:'center'}}>
                  <ul className="extra-options">
                    <li onClick={()=>{
                        if (!isLoading && !isCustomizePanelOpen) {
                          this.setState({isCustomizePanelOpen: true})
                        }
                      }}>
                      <MoreHoriz className="icon"/>Customize
                    </li>
                  </ul>
                  <div className={isLoading ? "publish-btn loading":"publish-btn"} onClick={this.onPublishClick.bind(this)}>
                    <span>{isLoading ? "Publishing...": "Publish"}</span>
                    {
                      isLoading ? <HourglassEmptyRounded className="icon" /> : <DoneAll className="icon" />
                    }
                  </div>
                </div>
              </section>
              <div className="topbar-progress" style={{width: `${progressPercent}%`}} />

              <>
                <div className="mobile-support">You'll need the desktop version to create a new Payge. We'll be bringing mobile real soon! :)</div>
                
                <ProPayge 
                  isPublishError={isPublishError}
                  isLoading={isLoading}
                  isEditing={true}
                  landingLinks={landingLinks}
                  onLinkAddClick={this.openNewLinkModal}
                  onLinkRemove={this.removeLandingLink}
                  onChangeBackground={()=>isBackgroundChooserOpen?false:this.setState({isBackgroundChooserOpen:true})}
                  isBackgroundChooserOpen={isBackgroundChooserOpen}
                  onDriveSelectDataChange={this.onDriveSelectDataChange}
                  onDropboxChooseDataChange={this.onDropboxChooseDataChange}
                  cloudButtonStyles={{driveStyles: gDriveButtonStyles, dropboxStyles: dropboxButtonStyles}}
                  downloadFile={{driveFile: driveFile, dropboxFile: dropboxFile}}
                  onDownloadFileChange={this.onDownloadFileChange}
                  selectedBackground={selected_bg}
                  landingLogo={landingLogo}
                  handleLandingLogoChange={this.handleLandingLogoChange}
                  // inputs properties
                  onLandingTitleChange={this.onLandingTitleChange}
                  onLandingDescriptionChange={this.onLandingDescriptionChange}
                  onFileNameChange={this.onFileNameChange}
                  landingTitle={landingTitle}
                  landingDescription={landingDescription}
                  fileName={fileName}
                  // customizations
                  themeColorName={currentThemeColorName}
                  sidebarStyle={currentSidebarStyle}  />

                {
                  isBackgroundChooserOpen ? (
                    <div className="bg-chooser">
                      <span className="bg-title">Select a background image</span>
                      <span className="bg-desc">Add an image to make your payge to look more catchy</span>
                      <div className="img-search-bar">
                        <input 
                          type="text" placeholder="Search for background images..."
                          onChange={this.handleImageSearchTextChange.bind(this)}
                          onKeyDown={this.handleOnKeyDown} />
                        <SearchSharp className="icon" ref="imgSearchInput" onClick={() => this.getUnsplashImages(img_search_text)} />
                      </div>
                      <ul className="backgrounds">
                        {
                          backgrounds.slice(0, 40).map((bg, index) => {
                            let liStyle = "inactive"
                            if (index === selected_bg.index) {
                              liStyle = "active"
                            }
                            return (
                              <li className={liStyle} onClick={() => this.selectBg(index)}>
                                <img src={bg.urls.thumb} />
                              </li>
                            )
                          })
                        }
                      </ul>
                      <span className="unsplash-attributions">Photos by respective artists on <a href="https://unsplash.com" target="_blank">Unsplash</a></span>
                      <div className="bg-action-container">
                        <span className="bg-action-btn" onClick={()=>this.setState({isBackgroundChooserOpen: false})}>Done</span>
                      </div>  
                    </div>
                  ) : false
                }

              </>

              <Modal
                isOpen={ video_isopen }
                ariaHideApp={false}
                contentLabel="How to?"
                style={yt_modal_styles}
                id="yt-video-modal">
                <div id="headerPopup" class="mfp-hide embed-responsive embed-responsive-21by9">
                  <iframe class="embed-responsive-item" width="854" height="480" src="https://www.youtube.com/embed/WiAS15V6sXs?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
              </Modal>

              <Modal
                isOpen={ isNewLinkModalOpen }
                isPublishError={isPublishError}
                ariaHideApp={false}
                contentLabel="Add link"
                className="link-popup"
                onRequestClose={() => this.setState({isNewLinkModalOpen: false})}
                shouldCloseOnOverlayClick={true}
                id="add-link-modal">
                <div className="add-link-content">
                  <input type="text" className="link-name" placeholder="Link title here"
                    value={newLinkName} onChange={(e)=>this.setState({newLinkName: e.target.value})} />
                  <input type="url" className="link-url" placeholder="https://your-link-here.com"
                    value={newLinkURL} onChange={(e)=>this.setState({newLinkURL: e.target.value})}
                    onKeyPress={(e) => e.which === 13 ? this.addNewLandingLink(newLinkName, newLinkURL): false} />
                  <span className="action-btn" onClick={()=>this.addNewLandingLink(newLinkName, newLinkURL)}>Add Link</span>
                </div>
              </Modal>

              {
                isCustomizePanelOpen ? (
                  <div className="customize-container">
                    <span className="customize-title">Change theme color</span>
                    <span className="customize-description">Pick a theme color to change color of the sidebar and external links</span>
                    <ul className="theme-colors">
                      {
                        themeColors.map(color => {
                          let liStyles = ''
                          if (color.name === currentThemeColorName) {
                            liStyles = "active"
                          }
                          return (
                            <li onClick={()=>this.setState({currentThemeColorName: color.name})} className={liStyles}>
                              <div style={{background:`rgb(${color.color[0]}, ${color.color[1]}, ${color.color[2]})`}}/>
                            </li>
                          )
                        })
                      }
                    </ul>
                    <span className="customize-title">Change sidebar layout</span>
                    <span className="customize-description">Select your choice of orientation for the sidebar at the right</span>
                    <ul className="sidebar-styles">
                      <li className={currentSidebarStyle === "diagonal" ? "active":"inactive"}
                        onClick={()=>this.setState({currentSidebarStyle: 'diagonal'})}><span><div /></span></li>
                      <li className={currentSidebarStyle === "straight" ? "active":"inactive"}
                        onClick={()=>this.setState({currentSidebarStyle: 'straight'})}><div className="straight"/></li>
                    </ul>

                    <span className="customize-action-btn" onClick={()=>this.setState({isCustomizePanelOpen: false})}>Done</span>
                  </div>
                ) : false
              }

              {/* <section id="footer-section">
                <img src={yashLogo} className="yash-logo" />
              </section> */}
            </div>
          ) : false
        }

      </>
    )
  }

}